'use strict';

class BlankIntegrationInstance {
  constructor(key, type, defaultValue) {
    this.key = key;
    this.type = type;
    this.value = defaultValue || '';
  }
}

module.exports = BlankIntegrationInstance;



// WEBPACK FOOTER //
// ./app/models/blankIntegrationInstance.js